import moment from 'moment-timezone'

import { KeyValueFilterOptions } from '@/components/shared-components/Filters/KeyValueFilter'
import { getIcon } from '@/utils/index'

import { PlatformActionSettingsUiQuery } from 'types/api.graphql'

export const checkActionExpired = (expiry: string | Date) => {
  if (!expiry) return false

  const now = moment()
  const actual = moment(expiry)

  if (actual < now) return true

  return false
}

export const checkActionDueSoon = (expiry: string | Date, days = 7) => {
  if (!expiry) return false

  const triggerDate = moment().add(days, 'days')
  const actual = moment(expiry)

  if (actual < triggerDate) return true

  return false
}

export const typesToKeyValueOptions = (
  types: PlatformActionSettingsUiQuery['platformActionSettings']['types']
): Record<string, KeyValueFilterOptions> => {
  if (!types?.length) return null

  return types.reduce((acc, { label, icon, colour }) => {
    return { ...acc, [label]: { label, icon: getIcon(icon), colour } }
  }, {})
}

export const prioritiesToKeyValueOptions = (
  priorities: PlatformActionSettingsUiQuery['platformActionSettings']['priorities']
): Record<string, KeyValueFilterOptions> => {
  if (!priorities?.length) return {}

  return priorities.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.label]: {
        label: curr.label,
        colour: curr.colour,
        icon: getIcon(curr.icon),
      },
    }),
    {}
  )
}
